import {
  GetInvitationsParams,
  InvitationsResponse,
  InviteMembersRequest,
} from "@/types";
import { apiFetch } from "../fetch";
import { getAccessToken } from "@/utils";

export async function inviteMembers(
  organizationId: string,
  data: InviteMembersRequest,
): Promise<InvitationsResponse> {
  const url = `/organizations/${encodeURIComponent(organizationId)}/invitations`;

  return apiFetch<InvitationsResponse>(url, {
    method: "POST",
    token: getAccessToken(),
    headers: {
      "x-saasbase-project-id": "proj_06fghx60hnrcxftadsj44e0pj8",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
}

export async function resendInvitation(
  organizationId: string,
  invitationId: string,
): Promise<InvitationsResponse> {
  const url = `/organizations/${encodeURIComponent(organizationId)}/invitations/${encodeURIComponent(invitationId)}/resend`;

  return apiFetch<InvitationsResponse>(url, {
    method: "POST",
    token: getAccessToken(),
    headers: {
      "x-saasbase-project-id": "proj_06fghx60hnrcxftadsj44e0pj8",
      "Content-Type": "application/json",
    },
  });
}

export async function cancelInvitation(
  organizationId: string,
  invitationId: string,
): Promise<InvitationsResponse> {
  const url = `/organizations/${encodeURIComponent(organizationId)}/invitations/${encodeURIComponent(invitationId)}/cancel`;

  return apiFetch<InvitationsResponse>(url, {
    method: "POST",
    token: getAccessToken(),
    headers: {
      "x-saasbase-project-id": "proj_06fghx60hnrcxftadsj44e0pj8",
      "Content-Type": "application/json",
    },
  });
}

export async function getInvitations(
  organizationId: string,
  params?: GetInvitationsParams,
): Promise<InvitationsResponse> {
  const queryParams = new URLSearchParams();

  if (params) {
    if (params.query) {
      queryParams.append("query", params.query);
    }
    if (params.status) {
      queryParams.append("status", params.status);
    }
    if (params.expired !== undefined) {
      queryParams.append("expired", params.expired.toString());
    }
    if (params.invited_by) {
      queryParams.append("invited_by", params.invited_by);
    }
    if (params.page !== undefined) {
      queryParams.append("page", params.page.toString());
    }
    if (params.limit !== undefined) {
      queryParams.append("limit", params.limit.toString());
    }
    if (params.order) {
      queryParams.append("order", params.order);
    }
    if (params.invitee_emails?.length) {
      params.invitee_emails.forEach((email) =>
        queryParams.append("invitee_emails", email),
      );
    }
    if (params.roles) {
      queryParams.append("roles", params.roles);
    }
  }

  const queryString = queryParams.toString();
  const url = `/organizations/${encodeURIComponent(organizationId)}/invitations${
    queryString ? `?${queryString}` : ""
  }`;

  return apiFetch<InvitationsResponse>(url, {
    method: "GET",
    token: getAccessToken(),
    headers: {
      "x-saasbase-project-id": "proj_06fghx60hnrcxftadsj44e0pj8",
    },
  });
}
